import {
    Avatar,
    Button,
    Checkbox,
    Chip,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    FormControl,
    Grid,
    IconButton,
    InputLabel,
    ListItem,
    makeStyles,
    Menu,
    MenuItem,
    Select,
    Typography,
} from "@material-ui/core"
import {
    AirlineSeatReclineNormal,
    DirectionsWalk,
    MoreVert,
    Motorcycle,
    NavigateNext,
    Print,
    PrintDisabled,
    Visibility,
} from "@material-ui/icons"
import { createContext, useContext, useEffect, useState } from "react"
import { useDrag } from "react-dnd"
import icon99 from "../../../assets/99-logo.jpg"
import iconClienteFiel from "../../../assets/icon-512x512.png"
import iconIfood from "../../../assets/ifood-logo.png"
import { silenciarAvisoTodasAbas } from "../../../components/OperacaoTempoReal"
import useListaContext from "../../../contexts/ListaContext"
import useRecebedor from "../../../contexts/RecebedorContext"
import RepresentanteSelector from "../../../functions/RepresentanteSelector"
import { RegistrarLogErro } from "../../../services/clientefiel"
import { alterarEstabelecimentoDoPedido } from "../../../services/integracao"
import useAppStore from "../../../stores/AppStore"
import { autoAceiteLigado } from "../../../stores/ConfigsStore"
import {
    COR_STATUS_CANCELADO,
    COR_STATUS_EM_ROTA,
    COR_STATUS_FINALIZADO,
    COR_STATUS_PRONTO,
} from "../../../utils/coresStatusPedido"
import { nomeFormaPagamentoPedido } from "../../../utils/formaPagamentoPedido"
import { useSnackbar } from "../../../utils/notificacoes"
import Loading from "../../Componentes/Loading"
import { FLUX_LOGO_URL } from "../../IntegracaoFlux/assets"
import { PICKNGO_LOGO_URL } from "../../IntegracaoPickngo/assets"
import { ObterPedido } from "../../RegistradorDePedidos/components/FinalizacaoPedido"
import DialogCobrancaPix from "../components/DialogCobrancaPix"
import DialogEmissaoFiscal from "../components/DialogEmissaoFiscal"
import DialogHistoricoPedido from "../components/DialogHistoricoPedido"
import { COLUNA_AGUARDANDO_ENTREGADOR, corDaRaia, verificarPrintQRCode } from "../functions"
import DetalhesEntregaFlux from "../IntegracaoFlux/components/DetalhesEntregaFlux"
import DetalhesEntregaPickngo from "../IntegracaoPickngo/components/DetalhesEntregaPickngo"
import { UberIcon } from "../IntegracaoUber/assets"
import IntegracaoUber from "../IntegracaoUber/IntegracaoUber"

const coresAgrupamentos = ["#f00a", "#0f0a", "#00fa", "#ff0a", "#0ffa", "#f0fa"]

const useStyles = makeStyles({
    pedido: props => {
        if (props.isDragging) {
            return {
                border: "2px dashed rgba(0,0,0,0.2)",
                padding: "0",
                borderRadius: "0",
                background: "transparent",
                boxShadow: "none",
                "& > *": {
                    opacity: 0,
                },
            }
        } else
            return {
                "& > *": {
                    opacity: 1,
                },
            }
    },
    maisOpcoes: {
        fontSize: "1.3rem",
    },
    statusTempoEntregaContainer: {
        "& > div:first-child": {
            paddingRight: "2px",
        },
        "& > div:last-child": {
            paddingLeft: "2px",
        },
    },
    status: {
        color: "white",
        minWidth: "100%",
        // Mesma cor da raia; no Finalizado, o cancelado fica em vermelho.
        backgroundColor: props => {
            switch (props.indexLista) {
                case 2:
                case COLUNA_AGUARDANDO_ENTREGADOR:
                case 3:
                    return corDaRaia(props.indexLista)
                case 4:
                    return props.statusPedido > 0 ? COR_STATUS_FINALIZADO : COR_STATUS_CANCELADO
                default:
                    return ""
            }
        },
    },
    tempoEntrega: {
        color: "white",
        minWidth: "100%",
        backgroundColor: props =>
            props.atraso > 0 ? "#dc3545" : props.atraso > -10 ? "#f0bb1f" : "#51a351",
    },
    valor_container: {
        marginBottom: "0.25rem",
        "& span": {
            display: "inline",
            overflow: "hidden",
            whiteSpace: "nowrap",
        },
        "& > .forma-pagamento-pedido-container": {
            display: "flex",
            justifyContent: "flex-end",
            paddingLeft: "2px",
        },
        "& > .valor-pedido-container": {
            display: "flex",
            paddingRight: "2px",
        },
        "& .forma-pagamento-pedido, .valor-pedido": {
            flex: 1,
        },
    },
    botoesIniciais: {
        display: "flex",
        gap: "0.5rem",
        alignItems: "center",
        width: "90%",
        marginTop: "0.5rem",
    },
    cancelarPedidoButton: {
        backgroundColor: "var(--cor-erro)",
        flex: 3,
        color: "white",
        "&:hover": {
            backgroundColor: "var(--cor-erro-hover)",
        },
    },
    vizualizarPedidoButton: {
        color: "black",
        flex: 2,
    },
    aceitarPedidoButton: {
        backgroundColor: "#28a745",
        color: "white",
        flex: 3,
        "&:hover": {
            backgroundColor: "#28a745",
        },
    },
    headerActionsContainer: {
        display: "grid",
        gap: "0.25rem",
        gridTemplateColumns: "2rem 2rem 2rem",
        gridTemplateRows: "2rem 2rem",
        float: "right",
        alignSelf: "right",
        "& > div > *": {
            height: "2rem",
            width: "2rem",
            padding: 0,
        },
        "& .actions-dropdown": {
            gridRow: 1,
            gridColumn: 1,
        },
        "& .actions-checkbox": {
            gridRow: 1,
            gridColumn: 2,
        },
        "& .actions-next": {
            gridRow: 1,
            gridColumn: 3,
            "& svg": {
                borderRadius: "100%",
                color: "white",
                // O botão "avançar" leva a cor da raia de DESTINO.
                backgroundColor: props => {
                    switch (props.indexLista) {
                        case 2:
                            return props.exibirAguardandoEntregador
                                ? COR_STATUS_PRONTO
                                : COR_STATUS_EM_ROTA
                        case COLUNA_AGUARDANDO_ENTREGADOR:
                            return props.tipoPedido === "0"
                                ? COR_STATUS_EM_ROTA
                                : COR_STATUS_FINALIZADO
                        case 3:
                            return COR_STATUS_FINALIZADO
                    }
                },
            },
        },
        "& .actions-agrupamento": {
            gridRow: 2,
            gridColumn: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            "& > div": {
                width: "1.5rem",
                height: "1.5rem",
                fontWeight: 500,
                backgroundColor: props => coresAgrupamentos[props.agrupamentoId - 1] ?? "#bbb",
            },
        },
        "& .actions-print": {
            gridRow: props => (props.statusPedido === 4 || props.statusPedido < 0 ? 1 : 2),
            gridColumn: 2,
        },
        "& .actions-delivery": {
            gridRow: props => (props.statusPedido === 4 || props.statusPedido < 0 ? 1 : 2),
            gridColumn: 3,
            "& .actions-delivery-motoboy": {
                color: props => (props.idEntregador ? "#28a745" : "5f5f5f"),
            },
        },
        "& svg": {
            fontSize: "1.3rem",
        },
    },
    botaoImprimir: {
        backgroundColor: "#007bff",
        color: "white",
        "&:hover": {
            backgroundColor: "#3399ff",
        },
    },
    botaoCancelar: {
        backgroundColor: "var(--cor-erro)",
        color: "white",
        "&:hover": {
            backgroundColor: "var(--cor-erro-hover)",
        },
    },
})

const PedidoContext = createContext()

const PedidoContextProvider = props => (
    <PedidoContext.Provider value={{ ...props }}>{props.children}</PedidoContext.Provider>
)

const LogoPlataforma = () => {
    const { pedido } = useContext(PedidoContext)

    if (pedido.plataforma === "ifood_integracao")
        return <img src={iconIfood} style={{ width: "25px" }} alt="Ícone ifood" />

    if (RepresentanteSelector.getRepresentante().isClienteFiel())
        return <img src={iconClienteFiel} style={{ width: "15px" }} alt="Ícone Cliente Fiel" />

    if (pedido.plataforma === "didi_food")
        return (
            <img
                src={icon99}
                style={{ width: "1.25rem", borderRadius: "100%" }}
                alt="Ícone 99food"
            />
        )

    return <></>
}

const InformacoesPedido = () => {
    const { pedido } = useContext(PedidoContext)

    return (
        <div>
            <Typography variant="body2">
                <LogoPlataforma /> <b>#{pedido.shortReference}</b> - {pedido.createdAt.slice(-5)}
            </Typography>
            {pedido.reference !== pedido.shortReference ? (
                <Typography variant="caption">{pedido.reference}</Typography>
            ) : null}
        </div>
    )
}

const NomeCliente = () => {
    const { pedido } = useContext(PedidoContext)

    return (
        <Typography component="span" color="textPrimary" className="text-capitalize">
            {pedido.customer.name}
            {pedido.type === "2"
                ? pedido.mesa
                    ? " - Mesa " + pedido.mesa
                    : " - Consumir no local"
                : ""}
        </Typography>
    )
}

// Logo redonda de uma integração de logística, no lugar do ícone de moto. Com mais de uma
// integração ativa, as logos dividem o mesmo espaço e cada uma abre o seu popup.
const LogoLogistica = ({ src, alt, tamanho, onClick }) => (
    <Avatar
        src={src}
        alt={alt}
        title={alt}
        onClick={e => {
            e.stopPropagation()
            onClick()
        }}
        style={{
            width: tamanho,
            height: tamanho,
            cursor: "pointer",
            border: "1px solid #ddd",
            backgroundColor: "white",
        }}
    />
)

const PedidoHeaderActions = props => {
    const {
        pedido,
        indexPedido,
        indexLista,
        mudarStatus,
        handlePrint,
        handleClickEntregadorIcon,
        corIconeUber,
        iconeUberPendente,
        agrupamentoId,
        logisticasIntegradas,
    } = useContext(PedidoContext)

    const { listaPedidosSelecionados, togglePedidoSelecionado } = useListaContext()

    const configuracoes = useAppStore(s => s.configuracoes)
    const tabStatus = useAppStore(s => s.tabStatus)

    const classes = useStyles({
        indexLista,
        assinaturaLimitada: configuracoes.user.parametros.assinaturaLimitada,
        agrupamentoId,
        statusPedido: pedido.status,
        idEntregador: pedido.idEntregador,
        exibirAguardandoEntregador: !!configuracoes.recebedor.exibirAbaAguardandoEntregador,
        tipoPedido: pedido.type,
    })

    const configs = useAppStore(s => s.configuracoes)

    const [anchorEl, setAnchorEl] = useState(null)
    const abrirDropdown = Boolean(anchorEl)

    const isPainelAtivo = tabStatus === "CRUD"
    const mostrarNextButton = /* isPainelAtivo && */ indexLista !== 1 && indexLista !== 4
    const mostrarCheckbox = isPainelAtivo && indexLista !== 1
    const integradoComUber = configuracoes.user?.parametros?.possuiIntegracaoUber

    const isAtivoNotaFiscal =
        configuracoes.user.parametros.ativarPlugNotas ||
        configuracoes.user.parametros.cnpjEstabelecimentoPlugNotas

    const Authorization = localStorage.getItem("chaveSistema")
    const [loading, setLoading] = useState(false)

    const { enqueueSnackbar } = useSnackbar()
    const alertStart = (msg, tipo) => {
        enqueueSnackbar(msg, { variant: tipo })
    }

    const [openDialogAlternar, setOpenDialogAlternar] = useState(false)
    const handleToggleAlternar = () => {
        setOpenDialogAlternar(prev => !prev)
    }

    const [estabelecimento, setEstabelecimento] = useState(pedido?.merchant?.id)
    const handleChangeEstabelecimento = e => {
        setEstabelecimento(e.target.value)
    }

    const handleOpenDropdownMenu = e => {
        setAnchorEl(e.currentTarget)
        e.stopPropagation()
    }

    const handleCloseDropdownMenu = e => {
        setAnchorEl(null)
        e.stopPropagation()
    }

    const [abrirEmissaoFiscal, setAbrirEmissaoFiscal] = useState(false)

    const handleAbrirEmissaoFiscal = e => {
        e.stopPropagation()
        setAnchorEl(null)
        setAbrirEmissaoFiscal(true)
    }

    const [abrirCobrancaPix, setAbrirCobrancaPix] = useState(false)

    const handleAbrirCobrancaPix = e => {
        e.stopPropagation()
        setAnchorEl(null)
        setAbrirCobrancaPix(true)
    }

    const [abrirHistorico, setAbrirHistorico] = useState(false)

    const handleAbrirHistorico = e => {
        e.stopPropagation()
        setAnchorEl(null)
        setAbrirHistorico(true)
    }

    // Pedido cancelado tem status negativo — não faz sentido gerar cobrança.
    const podeGerarCobrancaPix = !(pedido?.status < 0)

    const buscarPedidoEditar = async idPedido => {
        try {
            setLoading(true)
            const response = await ObterPedido(idPedido)
            if (response.retornoErro) {
                console.erros("Erro buscarPedidoEditar =>", response.mensagem)
                alertStart("Erro ao buscar o pedido", "error")
            } else {
                props.setPedidoEditar(response)
            }
        } catch (error) {
            console.erros("ERRO", error)
        } finally {
            setLoading(false)
        }
    }

    const alterarEstabelecimento = async (idPedido, idEstabelecimento) => {
        try {
            setLoading(true)
            const response = await alterarEstabelecimentoDoPedido(
                idPedido,
                idEstabelecimento,
                Authorization
            )
            if (response.retornoErro) {
                alertStart(response.mensagem, "error")
                setLoading(false)
                return false
            }
            alertStart(
                "O estabelecimento responsável pelo pedido foi alterado com sucesso",
                "success"
            )
            setLoading(false)
        } catch (error) {
            RegistrarLogErro(error, "handleChangeEstabelecimento")
        }
    }

    return (
        <div className={classes.headerActionsContainer}>
            <Loading loading={loading} />
            <Dialog
                maxWidth={"xs"}
                fullWidth
                open={openDialogAlternar}
                onClose={handleToggleAlternar}
                onClick={e => {
                    e.stopPropagation()
                }}
            >
                <DialogTitle>Trocar pedido de estabelecimento</DialogTitle>
                <DialogContent>
                    <FormControl variant="outlined" fullWidth>
                        <InputLabel>Estabelecimento</InputLabel>
                        <Select
                            value={estabelecimento}
                            label="Estabelecimento"
                            onChange={handleChangeEstabelecimento}
                        >
                            {props?.estabelecimentosRede?.map(estabelecimento => {
                                return (
                                    <MenuItem key={estabelecimento.id} value={estabelecimento.id}>
                                        {estabelecimento.nome}
                                    </MenuItem>
                                )
                            })}
                        </Select>
                    </FormControl>
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="contained"
                        style={{ backgroundColor: "var(--cor-erro)", color: "white" }}
                        onClick={e => {
                            e.stopPropagation()
                            handleToggleAlternar()
                        }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        variant="contained"
                        style={{ backgroundColor: "#5cb85c", color: "white" }}
                        onClick={e => {
                            e.stopPropagation()
                            alterarEstabelecimento(pedido.id, estabelecimento)
                            handleToggleAlternar()
                        }}
                    >
                        Confirmar
                    </Button>
                </DialogActions>
            </Dialog>
            <DialogCobrancaPix
                open={abrirCobrancaPix}
                pedido={pedido}
                onClose={() => setAbrirCobrancaPix(false)}
            />
            <DialogHistoricoPedido
                open={abrirHistorico}
                pedido={pedido}
                onClose={() => setAbrirHistorico(false)}
            />
            <>
                <IconButton
                    className="actions-dropdown"
                    id="dropdown-button"
                    onClick={handleOpenDropdownMenu}
                >
                    <MoreVert className={classes.maisOpcoes} />
                </IconButton>
                <Menu anchorEl={anchorEl} open={abrirDropdown} onClose={handleCloseDropdownMenu}>
                    <MenuItem
                        style={{ display: podeGerarCobrancaPix ? null : "none" }}
                        onClick={handleAbrirCobrancaPix}
                    >
                        Gerar cobrança Pix
                    </MenuItem>
                    <Divider style={{ display: podeGerarCobrancaPix ? null : "none" }} />
                    <MenuItem
                        style={{ display: isAtivoNotaFiscal ? null : "none" }}
                        onClick={handleAbrirEmissaoFiscal}
                    >
                        Nota Fiscal Consumidor
                    </MenuItem>
                    <Divider style={{ display: isAtivoNotaFiscal ? null : "none" }} />
                    <MenuItem
                        style={{ display: props?.estabelecimentosRede?.length > 1 ? null : "none" }}
                        onClick={e => {
                            e.stopPropagation()
                            handleToggleAlternar()
                        }}
                    >
                        Trocar Estabelecimento
                    </MenuItem>
                    <Divider
                        style={{ display: props?.estabelecimentosRede?.length > 1 ? null : "none" }}
                    />
                    <MenuItem
                        onClick={e => {
                            e.stopPropagation()
                            props.handleTogglePedido()
                            buscarPedidoEditar(props?.pedido?.id)
                        }}
                    >
                        Editar Pedido
                    </MenuItem>
                    <Divider
                        style={{
                            display:
                                props.pedido.type === "1" ||
                                (props.pedido.deliveryAddress.coordinates.latitude === 0 &&
                                    configs.user.parametros.calculoEntrega === 2)
                                    ? "none"
                                    : null,
                        }}
                    />
                    <MenuItem
                        style={{
                            display:
                                props.pedido.type === "1" ||
                                (props.pedido.deliveryAddress.coordinates.latitude === 0 &&
                                    configs.user.parametros.calculoEntrega === 2)
                                    ? "none"
                                    : null,
                        }}
                        onClick={e => {
                            e.stopPropagation()
                            const novaUrl = `/servicos/ferramenta/definir-area-de-entrega?lat=${props?.pedido?.deliveryAddress?.coordinates?.latitude}&lng=${props?.pedido?.deliveryAddress?.coordinates?.longitude}&idEstabelecimento=${props?.pedido?.merchant.id}`
                            const baseUrl = window.location.origin
                            window.open(`${baseUrl}${novaUrl}`, "_blank")
                        }}
                    >
                        Localização do Pedido
                    </MenuItem>
                    <Divider />
                    <MenuItem onClick={handleAbrirHistorico}>Ver Histórico</MenuItem>
                </Menu>
            </>
            {agrupamentoId ? (
                <div className="actions-agrupamento">
                    <Avatar>{agrupamentoId}</Avatar>
                </div>
            ) : null}
            {indexLista !== 4 ? (
                <div className="actions-checkbox" onClick={e => e.stopPropagation()}>
                    <Checkbox
                        onChange={() => togglePedidoSelecionado(pedido.id)}
                        checked={listaPedidosSelecionados.includes(pedido.id)}
                        size="small"
                    />
                </div>
            ) : null}
            {mostrarNextButton ? (
                <IconButton
                    className="actions-next pedido-next-status"
                    onClick={e => {
                        mudarStatus(pedido, indexPedido, false)
                        e.stopPropagation()
                    }}
                >
                    <NavigateNext className={classes.icone_proximo} />
                </IconButton>
            ) : null}
            <IconButton className="actions-delivery" onClick={handleClickEntregadorIcon}>
                {
                    // pedido.mesa
                    pedido.type === "2" ? (
                        <AirlineSeatReclineNormal />
                    ) : pedido.type === "1" ? (
                        <DirectionsWalk />
                    ) : integradoComUber ? (
                        <UberIcon color={corIconeUber} pendente={iconeUberPendente} />
                    ) : logisticasIntegradas.length > 0 ? (
                        <span style={{ display: "flex", gap: 2 }}>
                            {logisticasIntegradas.map(l => (
                                <LogoLogistica
                                    key={l.id}
                                    src={l.logo}
                                    alt={l.nome}
                                    tamanho={logisticasIntegradas.length > 1 ? 20 : 26}
                                    onClick={l.abrir}
                                />
                            ))}
                        </span>
                    ) : (
                        // O clique sobe para o IconButton (handleClickEntregadorIcon).
                        <Motorcycle className="actions-delivery-motoboy" />
                    )
                }
            </IconButton>
            <IconButton
                onClick={e => {
                    e.stopPropagation()
                    handlePrint()
                }}
                className="actions-print botao-impressao-manual"
            >
                {configuracoes.user.parametros.assinaturaLimitada ? <PrintDisabled /> : <Print />}
            </IconButton>
            <DialogEmissaoFiscal
                open={abrirEmissaoFiscal}
                onClose={() => setAbrirEmissaoFiscal(false)}
                pedido={pedido}
                alertStart={alertStart}
            />
        </div>
    )
}

function OpcoesIniciais() {
    const {
        pedido,
        mudarStatusPara,
        autorizacao,
        indexPedido,
        handleAbrirDetalhes,
        handlePrint,
        tipoPainelImpressao,
    } = useContext(PedidoContext)

    const configuracoes = useAppStore(s => s.configuracoes)
    const tabStatus = useAppStore(s => s.tabStatus)

    const [mostrarOpcoes, setMostrarOpcoes] = useState(true)

    const classes = useStyles()

    if (!mostrarOpcoes) return <></>

    const handleAceitarPedido = async e => {
        e.stopPropagation()
        if (pedido.status === 1 || pedido.status === 2) {
            //pedido ja esta aceito
            if (autoAceiteLigado(configuracoes.recebedor)) {
                setMostrarOpcoes(false)
            }
            mudarStatusPara(7, autorizacao, pedido, indexPedido)
            if (tipoPainelImpressao === "navegador") {
                handlePrint({
                    qtd: configuracoes.user.parametros?.viasImpressao,
                })
            }
        } else {
            //aceitar pedido
            await mudarStatusPara(1, autorizacao, pedido, indexPedido)
        }
        // Silencia o som em TODAS as abas do navegador (não só nesta): ao aceitar ou
        // preparar em uma aba, o aviso de novo pedido para em todas — inclusive nas que
        // ainda estavam tocando por causa do mesmo pedido.
        silenciarAvisoTodasAbas()
    }

    const handleCancelarPedido = e => {
        e.stopPropagation()
        mudarStatusPara(-1, autorizacao, pedido, indexPedido)
    }

    return (
        <span className={classes.botoesIniciais}>
            {tabStatus === "CRUD" && (
                <Button
                    onClick={handleCancelarPedido}
                    variant="contained"
                    size="small"
                    className={classes.cancelarPedidoButton}
                >
                    Cancelar
                </Button>
            )}
            <Button
                size="small"
                variant="contained"
                className={classes.vizualizarPedidoButton}
                onClick={handleAbrirDetalhes}
            >
                <Visibility />
            </Button>
            {tabStatus === "CRUD" && (
                <Button
                    onClick={handleAceitarPedido}
                    variant="contained"
                    size="small"
                    className={classes.aceitarPedidoButton}
                >
                    {pedido.status === 1 || pedido.status === 2 ? "Preparar" : "Aceitar"}
                </Button>
            )}
        </span>
    )
}

const ValorPedido = () => {
    const { pedido } = useContext(PedidoContext)

    const valor = Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
    }).format(pedido.totalPrice)

    return <Chip className="valor-pedido" size="small" label={valor} />
}

const NomeFormaPagamento = () => {
    const { pedido } = useContext(PedidoContext)

    return (
        <Chip
            size="small"
            className="forma-pagamento-pedido"
            label={pedido.status >= 0 ? nomeFormaPagamentoPedido(pedido) : ""}
        />
    )
}

const EnderecoEntrega = props => (
    <Typography variant="subtitle2" color="textSecondary">
        {props.endereco.neighborhood} - {props.endereco.streetName}, {props.endereco.streetNumber}
    </Typography>
)

const NomeEntregadorAssociado = props => (
    <Typography
        id={`entregador-pedido-${props.idPedido}`}
        variant="subtitle2"
        color="textSecondary"
    >
        Entregador: {props.nomeEntregador}
    </Typography>
)

const timeFormatter = Intl.NumberFormat("pt-BR", {
    style: "decimal",
    minimumIntegerDigits: 2,
    // minimumSignificantDigits: 2,
})

const mesFormatado = data => {
    if (!data) return

    const mes = (data.getMonth() + 1).toString()

    if (mes.length === 1) return "0" + mes
    return mes
}

export default function PedidoCard(props) {
    const configuracoes = useAppStore(s => s.configuracoes)

    const { enqueueSnackbar } = useSnackbar()
    const { openModalPedido } = useRecebedor()

    const [{ isDragging }, dragRef] = useDrag({
        type: "CARD",
        item: () => ({
            pedido: pedido,
            indexListaAtual: indexLista,
            indexPedido: indexPedido,
        }),
        collect: monitor => ({
            isDragging: monitor.isDragging(),
        }),
    })

    const alertStart = (msg, tipo) => {
        enqueueSnackbar(msg, { variant: tipo })
    }

    const {
        indexLista,
        pedido,
        indexPedido,
        autorizacao,
        mudarStatusPara,
        mudarStatus,
        procurarMotoqueiros,
        solicitarEntregaFuiDelivery,
        buscarStatus,
        tipoPainelImpressao,
        setAbrirDialogMotoqueiros,
        estabelecimentosRede,
    } = props

    const tempoDesdePedido = Math.floor((Date.now() - new Date(pedido.createdAt).getTime()) / 60000)
    const atraso = Math.floor((Date.now() - new Date(pedido.deliveryDateTime).getTime()) / 60000)

    const classes = useStyles({
        indexLista,
        isDragging,
        statusPedido: pedido.status,
        tempoDesdePedido,
        atraso,
        exibirAguardandoEntregador: !!configuracoes.recebedor.exibirAbaAguardandoEntregador,
        tipoPedido: pedido.type,
    })

    const tabStatus = useAppStore(s => s.tabStatus)
    const agrupamentos = useAppStore(s => s.agrupamentos)
    const { togglePedidoSelecionado, limparListaPedidosSelecionados } = useListaContext()

    const [expandIntegracaoUber, setExpandIntegracaoUber] = useState(false)
    const toggleExpandIntegracaoUber = e => setExpandIntegracaoUber(prev => !prev)

    const [corIconeUber, setCorIconeUber] = useState()
    const [iconeUberPendente, setIconeUberPendente] = useState(false)

    const integradoComUber = configuracoes.user?.parametros?.possuiIntegracaoUber
    const integradoComFlux = configuracoes.user?.parametros?.possuiIntegracaoFlux
    const [abrirDetalhesFlux, setAbrirDetalhesFlux] = useState(false)
    const integradoComPickngo = configuracoes.user?.parametros?.possuiIntegracaoPickngo
    const [abrirEntregaPickngo, setAbrirEntregaPickngo] = useState(false)

    // Logísticas integradas ativas na loja (só para delivery): viram as logos no lugar da moto.
    const logisticasIntegradas =
        pedido.type === "0"
            ? [
                  integradoComPickngo && {
                      id: "pickngo",
                      nome: "Pick'n Go",
                      logo: PICKNGO_LOGO_URL,
                      abrir: () => setAbrirEntregaPickngo(true),
                  },
                  integradoComFlux && {
                      id: "flux",
                      nome: "Flux",
                      logo: FLUX_LOGO_URL,
                      abrir: () => setAbrirDetalhesFlux(true),
                  },
              ].filter(Boolean)
            : []

    const permiteModuloMotoqueiro = () => {
        switch (indexLista) {
            case 4:
                return false
            default:
                return true
        }
    }

    const possuiIntegracaoEntrega = () => {
        return (
            configuracoes.user.parametros.ativarFuiDelivery &&
            configuracoes.user.parametros.passwordFuiDelivery &&
            configuracoes.user.parametros.usernameFuiDelivery &&
            configuracoes.user.parametros.clienteIdFuiDelivery
        )
    }

    const handleAbrirDetalhes = () => openModalPedido(pedido)

    const handleClickEntregadorIcon = e => {
        e.stopPropagation()

        if (integradoComUber && pedido.type === "0") {
            toggleExpandIntegracaoUber()
            return
        }

        // Com logística integrada (Pick'n Go / Flux) o lugar da moto mostra as logos, e cada logo abre o
        // seu popup; um clique fora delas (na borda do botão) abre a primeira.
        if (logisticasIntegradas.length > 0) {
            logisticasIntegradas[0].abrir()
            return
        }

        if (pedido.type !== "2" && pedido.type !== "1") {
            if (possuiIntegracaoEntrega()) {
                solicitarEntregaFuiDelivery(autorizacao, pedido)
            } else if (permiteModuloMotoqueiro() && tabStatus === "CRUD") {
                limparListaPedidosSelecionados()
                togglePedidoSelecionado(pedido.id)
                setAbrirDialogMotoqueiros(true)
            }
        }
    }

    const mandarImprimir = useAppStore(s => s.mandarImprimir)

    const [dialogImprimir, setDialogImprimir] = useState(false)
    const [textos, setTextos] = useState([])
    const [selecionadas, setSelecionadas] = useState([])
    const textosPossiveis = ["texto", "texto1", "texto2", "texto3", "texto4", "texto5"]

    useEffect(() => {
        setSelecionadas(textos.map(t => (t.key === "texto" ? t.key : null)))
    }, [textos])

    const toggleImpressora = key => {
        setSelecionadas(prev => (prev.includes(key) ? prev.filter(k => k !== key) : [...prev, key]))
    }

    const handlePrint = customParams => {
        const textosValidos = textosPossiveis
            .map(k => ({ key: k, value: pedido?.[k] }))
            .filter(t => typeof t.value === "string" && t.value.trim().length > 0)

        const maisDeUmaImpressora = textosValidos.length >= 2

        setTextos(textosValidos)
        if (
            !!configuracoes.user.parametros.impressaoAlternada &&
            maisDeUmaImpressora &&
            tipoPainelImpressao !== "navegador"
        ) {
            setDialogImprimir(true)
        } else {
            mandarImprimir({
                pedido,
                texto: pedido.texto,
                qtd: customParams?.qtd ?? 1,
                qrcode: verificarPrintQRCode(pedido),
                imprimirNota: true,
                reimpressaoManual: true,
            })
        }
    }

    const confirmarImpressao = customParams => {
        const selecionados = textos.filter(t => selecionadas.includes(t.key))

        textosPossiveis.map(ts => {
            if (pedido[ts]) {
                if (selecionados.filter(s => s.key === ts)?.length < 1) pedido[ts] = null
            }
            return null
        })

        mandarImprimir({
            pedido,
            texto: pedido.texto,
            qtd: customParams?.qtd ?? 1,
            qrcode: verificarPrintQRCode(pedido),
            imprimirNota: true,
            reimpressaoManual: true,
        })

        setDialogImprimir(false)
    }

    if (indexPedido > configuracoes.recebedor.exibicaoMaxima) return null

    const agrupamentoId = agrupamentos.findIndex(a => a === pedido.agrupamento) + 1

    const dataAgendamento = pedido.dataAgendamentoStart
        ? new Date(pedido.dataAgendamentoStart)
        : null
    const dataAgendamentoTexto = dataAgendamento
        ? `${timeFormatter.format(dataAgendamento.getDate())}/${timeFormatter.format(
              dataAgendamento.getMonth() + 1
          )} - ${timeFormatter.format(dataAgendamento.getHours())}:${timeFormatter.format(
              dataAgendamento.getMinutes()
          )}`
        : null

    const statusPedidoLabel =
        dataAgendamento && pedido.status >= 0
            ? "Agendado " + dataAgendamentoTexto
            : indexLista !== 1
            ? buscarStatus(pedido)
            : ""

    return (
        <span key={pedido.id}>
            <PedidoContextProvider
                pedido={pedido}
                indexPedido={indexPedido}
                indexLista={indexLista}
                classes={classes}
                mudarStatus={mudarStatus}
                mudarStatusPara={mudarStatusPara}
                handlePrint={handlePrint}
                tipoPainelImpressao={tipoPainelImpressao}
                autorizacao={autorizacao}
                handleClickEntregadorIcon={handleClickEntregadorIcon}
                procurarMotoqueiros={procurarMotoqueiros}
                corIconeUber={corIconeUber}
                setCorIconeUber={setCorIconeUber}
                possuiIntegracaoEntrega={possuiIntegracaoEntrega}
                solicitarEntregaFuiDelivery={solicitarEntregaFuiDelivery}
                permiteModuloMotoqueiro={permiteModuloMotoqueiro}
                iconeUberPendente={iconeUberPendente}
                setIconeUberPendente={setIconeUberPendente}
                handleAbrirDetalhes={handleAbrirDetalhes}
                setAbrirDialogMotoqueiros={setAbrirDialogMotoqueiros}
                agrupamentoId={agrupamentoId}
                logisticasIntegradas={logisticasIntegradas}
            >
                <ListItem
                    id={`pedido-${pedido.id}`}
                    key={pedido.id}
                    disableGutters
                    button
                    onClick={handleAbrirDetalhes}
                    ref={pedido.status >= 1 && indexLista !== 1 ? dragRef : null}
                    className={classes.pedido}
                    divider
                >
                    <Grid container>
                        <Grid container item xs={12} justifyContent="space-between">
                            <Grid container item justifyContent="space-between" xs={12}>
                                <Grid item xs={6}>
                                    <InformacoesPedido />
                                    <NomeCliente />
                                </Grid>
                                {pedido.status !== 0 ? (
                                    <PedidoHeaderActions
                                        handleTogglePedido={props.handleTogglePedido}
                                        pedido={pedido}
                                        setPedidoEditar={props.setPedidoEditar}
                                        estabelecimentosRede={estabelecimentosRede}
                                    />
                                ) : null}
                            </Grid>

                            <Grid container item xs={12} className={classes.valor_container}>
                                <Grid item xs={4} className="valor-pedido-container">
                                    <ValorPedido />
                                </Grid>
                                <Grid item xs={8} className="forma-pagamento-pedido-container">
                                    {dataAgendamento ? null : <NomeFormaPagamento />}
                                </Grid>
                            </Grid>
                            <Grid
                                container
                                item
                                xs={12}
                                className={classes.statusTempoEntregaContainer}
                            >
                                <Grid
                                    item
                                    xs={4}
                                    direction="row"
                                    wrap="nowrap"
                                    spacing={1}
                                    alignItems="center"
                                >
                                    {pedido.status !== 0 && statusPedidoLabel ? (
                                        <Chip
                                            size="small"
                                            label={statusPedidoLabel}
                                            className={classes.status}
                                        />
                                    ) : null}
                                </Grid>
                                {configuracoes.recebedor.exibirTempoEspera &&
                                pedido.status > 0 &&
                                pedido.status !== 4 &&
                                !dataAgendamento ? (
                                    <Grid item container xs={8} justifyContent="flex-end">
                                        <Chip
                                            fullWidth
                                            className={classes.tempoEntrega}
                                            size="small"
                                            label={
                                                (atraso > 0
                                                    ? "Atrasado em " + atraso
                                                    : tempoDesdePedido) + " minutos"
                                            }
                                        />
                                    </Grid>
                                ) : null}
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            {configuracoes.recebedor.mostrarEndereco &&
                                pedido.deliveryAddress.streetName !== "Buscar no local" && (
                                    <EnderecoEntrega endereco={pedido.deliveryAddress} />
                                )}
                            {configuracoes.recebedor.mostrarEntregador && pedido.nomeEntregador && (
                                <NomeEntregadorAssociado
                                    nomeEntregador={pedido.nomeEntregador}
                                    idPedido={pedido.id}
                                />
                            )}
                        </Grid>
                        <Grid container item xs={12} justifyContent="center">
                            {indexLista !== 1 && pedido.type === "0" && integradoComUber && (
                                <IntegracaoUber
                                    expandIntegracaoUber={expandIntegracaoUber}
                                    setExpandIntegracaoUber={setExpandIntegracaoUber}
                                    pedido={pedido}
                                    indexPedido={indexPedido}
                                    autorizacao={autorizacao}
                                    mudarStatus={mudarStatus}
                                    setCorIconeUber={setCorIconeUber}
                                    setIconeUberPendente={setIconeUberPendente}
                                    alertStart={alertStart}
                                />
                            )}
                            {indexLista === 1 && <OpcoesIniciais />}
                        </Grid>
                    </Grid>
                </ListItem>
                {integradoComPickngo && abrirEntregaPickngo && (
                    <DetalhesEntregaPickngo
                        aberto={abrirEntregaPickngo}
                        onClose={() => setAbrirEntregaPickngo(false)}
                        pedido={pedido}
                        autorizacao={autorizacao}
                    />
                )}
                {integradoComFlux && (
                    <DetalhesEntregaFlux
                        aberto={abrirDetalhesFlux}
                        onClose={() => setAbrirDetalhesFlux(false)}
                        pedido={pedido}
                        autorizacao={autorizacao}
                    />
                )}
                <Dialog
                    maxWidth="xs"
                    fullWidth
                    open={dialogImprimir}
                    onClose={() => setDialogImprimir(false)}
                >
                    <DialogTitle>Impressão Alternada</DialogTitle>

                    <DialogContent>
                        {textos.map(t => {
                            return (
                                <Grid
                                    key={t.key}
                                    item
                                    container
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    alignItems="center"
                                    wrap="nowrap"
                                >
                                    <Checkbox
                                        size="small"
                                        checked={selecionadas.includes(t.key)}
                                        onChange={() => toggleImpressora(t.key)}
                                    />
                                    {t.key === "texto" ? (
                                        <Typography>Impressão Completa</Typography>
                                    ) : (
                                        <Typography>Impressora {t?.key?.slice(-1) || 1}</Typography>
                                    )}
                                </Grid>
                            )
                        })}
                    </DialogContent>

                    <DialogActions>
                        <Button
                            className={classes.botaoCancelar}
                            onClick={() => setDialogImprimir(false)}
                        >
                            Cancelar
                        </Button>

                        <Button
                            className={classes.botaoImprimir}
                            onClick={() => confirmarImpressao()}
                            disabled={selecionadas.length === 0}
                        >
                            Imprimir
                        </Button>
                    </DialogActions>
                </Dialog>
            </PedidoContextProvider>
        </span>
    )
}
